export default {
  system: {
    user: 'ユーザー',
    level: 'レベル',
    earnPerTap: 'タップ毎の獲得',
    coinsToLevelUp: 'レベルアップに必要なコイン',
    profitPerHour: '1時間あたりの利益',
    coming1: '近日中に',
    coming2: '面白いものが登場します...',
    close: '閉じる',
    friends: '友達',
    continue: '続ける',
  },
  settings: {
    chooseNetwork: 'ネットワークを選択',
    chooseLanguage: '言語を選択',
  },
  popup_CheckTask: {
    join: '参加する',
    check: '確認する',
    taskIsNotCompleted: 'タスクが完了していません',
  },
  popup_levelUp: {
    levelUp: 'レベルアップ！',
    multiTap: 'マルチタップ',
    energyLimit: 'エネルギー制限',
  },
  popup_BalanceUp: {
    balanceUp: '残高更新！',
    balanceDiffSinceLast: 'あなたの報酬',
  },
  popup_BalanceTip: {
    tip: '利益をブーストする',
    message: 'マインメニューをタップしてネットワークのアップグレードを購入',
    description: 'オフラインでも最大3時間まで獲得可能',
  },
  popup_Bored: {
    header: 'カエルが退屈しています！',
    message: 'カエルと遊んでください。',
    description: '3時間カエルと遊ばないと、利益が停止します',
  },
  popup_Hungry: {
    header: 'カエルがお腹を空かせています！',
    message: 'カエルに餌をあげてください。',
    description: '友達が多いほど、各給餌でより多くのコインを獲得できます',
  },
  menu: {
    network: 'ネットワーク',
    mine: 'マイン',
    earn: '稼ぐ',
    food: '食べ物',
  },
  tap: {
    bored: '退屈',
    fun: '楽しい',
  },
  mineMenu: {
    activities: 'アクティビティ',
    investments: '投資',
    web3: 'WEB3',
    achievements: '実績',
  },
  leaderboard: {
    from: 'から',
    beTheFirst: '1位になろう！',
  },
  mine: {
    joinOurTG1: '私たちのTelegramチャンネルに参加して、',
    joinOurTG2: 'ロック解除しましょう！',
    unlock: 'ロック解除',
  },
  friends: {
    inviteFriends: '友達を招待しよう！',
    receiveBonuses: 'あなたと友達がボーナスを受け取れます',
    inviteFriend: '友達を招待',
    withTelegramPremium: 'Telegram Premiumで',
    forYouAndYourFriend: 'あなたと友達のために',
    moreBonuses: 'さらなるボーナス',
    listOfYourFriends: '友達リスト',
    linkCopied: '招待リンクがクリップボードにコピーされました！',
    playWithMe:
      '私と一緒に参加して、エアドロップでトークンを獲得しよう！\n' +
      '💰 ギフトをゲット！新規参加者に+3000コイン\n' +
      '🚀 Telegram Premiumをお持ちですか？+5000コインをゲット！\n',
  },
  earn: {
    moreCoins: 'さらにコインを獲得しよう！',
    dailyTasks: 'デイリータスク',
    dailyReward: 'デイリー報酬',
    tasksList: 'タスクリスト',
    joinOurTG: '私たちのTelegramチャンネルに参加',
    followOurX: '私たちのXアカウントをフォロー',
    yourAd: 'ここに広告を掲載できます',
    connect: '私たちのTelegramチャンネルの管理者に連絡',
  },
  food: {
    hungry: 'お腹が空いた',
    full: '満腹',
    frogIsFull: 'カエルは満腹です',
    feed: '餌をあげる',
    bonus: 'ボーナス',
    satiety: '満腹度',
    hours: '時間',
  },
  toast: {
    buyCard: {
      title: '実績解除！',
      subtitle: 'カエル帝国を偉大な存在に導く時が来ました 👑',
    },
    feedFrog: {
      title: 'カエルが喜んでいます！',
      subtitle: 'よくできました！ペットに餌をあげて笑顔を保ちましょう 🍽️',
    },
  },
};
